import React, { useEffect, useState, useContext } from "react";
import Category from "./Category";
import eventEmitter from "../eventEmitter";
import BrandSelection from "./BrandSelection";
import config from "../../../../config";
import { EquipmentContext } from "../useContext/context";
import VarOnlySection from "./VarOnlySection";

const PAYCHEX_ORG_ID = config.paymentcloud.PAYCHEX_ORG_ID;
const EMS_ORG_ID = config.paymentcloud.EMS_ORG_ID;

const Equipments = ({
    selectedEquipments,
    emsEquipments,
    setFormDataByKeyValue,
    errors,
    form_data,
    allEquipments,
    removeError,
}) => {
    const [selected_equipments, setSelectedEquipments] = useState([]);
    const [terminals, setTerminals] = useState([]);
    const [gateways, setGateway] = useState([]);
    const [addons, setAddons] = useState([]);

    const { org_id } = useContext(EquipmentContext);

    useEffect(() => {
        const { t, g, a } = emsEquipments.reduce(
            (acc, category) => {
                if (category.equipments_type === "terminal") {
                    acc.t.push(category);
                } else if (category.equipments_type === "gateway") {
                    acc.g.push(category);
                } else if (category.equipments_type === "add_on") {
                    acc.a.push(category);
                } else {
                }
                return acc;
            },
            { t: [], g: [], a: [] },
        );
        setTerminals(t);
        setGateway(g);
        setAddons(a);
    }, [emsEquipments]);
    useEffect(() => {
        if (typeof selectedEquipments === "string") {
            setFormDataByKeyValue("equipments", JSON.parse(selectedEquipments));
            setSelectedEquipments(JSON.parse(selectedEquipments));
        }
    }, [selectedEquipments]);
    useEffect(() => {
        setFormDataByKeyValue("equipments", selected_equipments);
        removeError("equipments");
    }, [selected_equipments]);
    useEffect(() => {
        eventEmitter.on("updateEquipment", handleMessage);
        // Cleanup to prevent memory leaks
        return () => {
            eventEmitter.off("updateEquipment", handleMessage);
        };
    }, []);

    const handleMessage = (updated_equipments) => {
        setSelectedEquipments(updated_equipments);
    };
    return (
        <div>
            {errors?.equipments &&
                Array.isArray(errors.equipments) &&
                errors.equipments.map((error) => (
                    <span className="error-message">{error}</span>
                ))}

            {org_id == PAYCHEX_ORG_ID && (
                <BrandSelection
                    updateSelectedEquipments={setSelectedEquipments}
                    allEquipments={allEquipments}
                    org_id={org_id}
                />
            )}

            {terminals.map(
                (category, index) =>
                    category.equipments.length > 0 && (
                        <div className="equipments-section mt-2r">
                            <h6 className="sub-heading">
                                {category.category_free_text}
                            </h6>
                            <p className="sub-heading-lead">
                                {category.category_description}
                            </p>
                            <Category
                                key={index}
                                category={category}
                                selectedEquipments={selected_equipments}
                                updateSelectedEquipments={setSelectedEquipments}
                                form_data={form_data}
                                setFormDataByKeyValue={setFormDataByKeyValue}
                                allEquipments={allEquipments}
                                enableLegend={
                                    category.category_name !=
                                    category.category_free_text
                                }
                            />
                        </div>
                    ),
            )}

            {gateways.map(
                (category, index) =>
                    category.equipments.length > 0 && (
                        <div className="equipments-section mt-2r">
                            <h6 className="sub-heading">
                                {category.category_free_text}
                            </h6>
                            <p className="sub-heading-lead">
                                {category.category_description}
                            </p>
                            <Category
                                key={index}
                                category={category}
                                selectedEquipments={selected_equipments}
                                updateSelectedEquipments={setSelectedEquipments}
                                form_data={form_data}
                                setFormDataByKeyValue={setFormDataByKeyValue}
                                allEquipments={allEquipments}
                                enableLegend={
                                    category.category_name !=
                                    category.category_free_text
                                }
                            />
                        </div>
                    ),
            )}

            {addons.map(
                (category, index) =>
                    category.equipments.length > 0 && (
                        <div className="equipments-section mt-2r">
                            <h6 className="sub-heading">
                                {category.category_free_text}
                            </h6>
                            <p className="sub-heading-lead">
                                {category.category_description}
                            </p>
                            <Category
                                key={index}
                                category={category}
                                selectedEquipments={selected_equipments}
                                updateSelectedEquipments={setSelectedEquipments}
                                form_data={form_data}
                                setFormDataByKeyValue={setFormDataByKeyValue}
                                allEquipments={allEquipments}
                                enableLegend={
                                    category.category_name !=
                                    category.category_free_text
                                }
                            />
                        </div>
                    ),
            )}

            {/* Add the VAR Only Section */}
            <VarOnlySection
                updateSelectedEquipments={setSelectedEquipments}
                selectedEquipments={selected_equipments}
            />
        </div>
    );
};

export default Equipments;
